import * as React from 'react';
import { useEffect } from 'react';

import Banner, { BannerData } from '@/components/elements/Banner';
import useScript, { Status } from '@/hooks/useScript';
import { BannerAreaLabel } from '@/lib/dmm/trackingTag/type';

interface TopBannerListProps {
  bannerList: BannerData[];
  bannerArea: BannerAreaLabel;
}

const TopBannerList: React.FC<TopBannerListProps> = ({
  bannerList,
  bannerArea,
}) => {
  const gtaScript = useScript('/customGtaScript.js?20241120');

  /** クリックイベント */
  const clickEvent = (alt?: string, id?: string) => {
    if (alt && id && gtaScript === Status.Ready) {
      if (alt === 'DMMプレミアム新規登録30日間無料') {
        // プレミアムバナーのイベント通知
        window.sendPremiumBannerClickEvent(bannerArea);
      } else {
        // 上記以外のイベントのクリック通知
        window.sendKeirinBannerClickEvent(bannerArea, id, alt);
      }
    }
  };

  useEffect(() => {
    if (gtaScript === Status.Ready) {
      bannerList.forEach(b => {
        if (b.alt && b.alt === 'DMMプレミアム新規登録30日間無料') {
          window.sendPremiumBannerViewEvent(bannerArea);
        }
      });
    }
  }, [gtaScript]);

  return (
    <>
      {bannerList.map((banner, i) => (
        <li
          key={`${banner.link}${i}`}
          onClick={() => {
            clickEvent(banner.alt, banner.bannerId);
          }}
        >
          <Banner {...banner} />
        </li>
      ))}
    </>
  );
};

export default TopBannerList;
